/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_description = /** @type {(inputs: {}) => string} */ () => {
	return `Popis`
};

const da_description = /** @type {(inputs: {}) => string} */ () => {
	return `Beskrivelse`
};

const de_description = /** @type {(inputs: {}) => string} */ () => {
	return `Beschreibung`
};

const en_description = /** @type {(inputs: {}) => string} */ () => {
	return `Description`
};

const es_description = /** @type {(inputs: {}) => string} */ () => {
	return `Descripción`
};

const fr_description = /** @type {(inputs: {}) => string} */ () => {
	return `Description`
};

const hu_description = /** @type {(inputs: {}) => string} */ () => {
	return `Leírás`
};

const it_description = /** @type {(inputs: {}) => string} */ () => {
	return `Descrizione`
};

const nl_description = /** @type {(inputs: {}) => string} */ () => {
	return `Beschrijving`
};

const pl_description = /** @type {(inputs: {}) => string} */ () => {
	return `Opis`
};

const pt_description = /** @type {(inputs: {}) => string} */ () => {
	return `Descrição`
};

const sv_description = /** @type {(inputs: {}) => string} */ () => {
	return `Beskrivning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("description", locale)
	if (locale === "cs") return cs_description(inputs)
	if (locale === "da") return da_description(inputs)
	if (locale === "de") return de_description(inputs)
	if (locale === "en") return en_description(inputs)
	if (locale === "es") return es_description(inputs)
	if (locale === "fr") return fr_description(inputs)
	if (locale === "hu") return hu_description(inputs)
	if (locale === "it") return it_description(inputs)
	if (locale === "nl") return nl_description(inputs)
	if (locale === "pl") return pl_description(inputs)
	if (locale === "pt") return pt_description(inputs)
	return sv_description(inputs)
};